/*
  AIA 2026-10-29: lazy product-photo zoom.
  Debut's theme.js sets up the hover zoom for every photo in the product
  gallery as soon as the page loads on desktop, which downloads a 2048px
  zoom file for each of them (26 files, about 3.3 MB on a 48-variant set)
  even though only one photo is on screen. This file replaces two methods
  of theme.Product so that only the visible photo gets its zoom image, and
  a photo switched in by a thumbnail or variant gets its zoom image at that
  moment. It must load after theme.js and before the sections start
  (both scripts are deferred, so document order is enough).
*/
(function () {
  if (!window.theme || !theme.Product || !window.jQuery || !window.enquire) {
    return;
  }
  var $ = jQuery;
  var proto = theme.Product.prototype;
  if (!proto._initBreakpoints || !proto._switchImage) {
    return;
  }

  function enableZoom(el) {
    var $el = $(el);
    if ($el.data('aiaZoomReady')) {
      return;
    }
    $el.zoom({ url: $el.data('zoom') });
    $el.data('aiaZoomReady', true);
  }

  function destroyZoom(el) {
    $(el).trigger('zoom.destroy').removeData('aiaZoomReady');
  }

  // Same as Debut's _initBreakpoints, except the medium-up branch only
  // zooms the photo that is not hidden.
  proto._initBreakpoints = function () {
    var self = this;

    enquire.register(this.settings.mediaQuerySmall, {
      match: function () {
        if ($(self.selectors.productThumbImages).length > 3) {
          self._initThumbnailSlider();
        }
        if (self.settings.zoomEnabled) {
          $(self.selectors.productImageWraps).each(function () {
            destroyZoom(this);
          });
        }
        self.settings.bpSmall = true;
      },
      unmatch: function () {
        if (self.settings.sliderActive) {
          self._destroyThumbnailSlider();
        }
        self.settings.bpSmall = false;
      }
    });

    enquire.register(this.settings.mediaQueryMediumUp, {
      match: function () {
        if (self.settings.zoomEnabled) {
          $(self.selectors.productImageWraps)
            .not('.' + self.classes.hidden)
            .each(function () {
              enableZoom(this);
            });
        }
      }
    });
  };

  // After Debut shows the chosen photo, give it its zoom image (desktop only).
  var originalSwitchImage = proto._switchImage;
  proto._switchImage = function (imageId) {
    originalSwitchImage.call(this, imageId);
    if (this.settings.zoomEnabled && !this.settings.bpSmall) {
      $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      ).each(function () {
        enableZoom(this);
      });
    }
  };
})();
